export default __webpack_public_path__ + "static/media/wipay-logo.c5ffd974.png";